import { Link } from 'react-router-dom';
import { useState } from 'react';
import { videoCategories } from '@/mocks/videos';

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <section className="relative w-full min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20cinematic%20entertainment%20background%20with%20abstract%20flowing%20gradient%20shapes%20in%20warm%20red%20orange%20and%20golden%20tones%2C%20soft%20bokeh%20lights%2C%20luxurious%20theater%20atmosphere%2C%20elegant%20dark%20gradient%2C%20minimal%20composition%2C%20high%20quality%20abstract%20art&width=1920&height=1080&seq=qiezi-hero-bg&orientation=landscape"
          alt="茄子视频"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-sm mb-6">
            <i className="ri-fire-line text-accent-500"></i>
            <span>2026暑期档火热进行中 · 海量新片每日更新</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
            海量高清视频
            <span className="block text-accent-400">随时随地 免费观看</span>
          </h1>

          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto">
            无需下载，打开即看。支持多种分辨率自由切换，流畅播放不卡顿。
          </p>

          <div className="flex items-center max-w-lg mx-auto bg-white rounded-full shadow-lg overflow-hidden mb-10">
            <div className="flex-1 flex items-center px-5">
              <i className="ri-search-line text-foreground-400 text-lg mr-3"></i>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索你喜欢的电影、电视剧、综艺..."
                className="w-full py-3.5 text-sm text-foreground-900 placeholder-foreground-400 bg-transparent focus:outline-none"
              />
            </div>
            <button className="px-8 py-3.5 bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap">
              搜索
            </button>
          </div>

          <div className="flex items-center justify-center flex-wrap gap-2">
            {videoCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/15 text-white text-sm hover:bg-white/20 hover:border-white/30 transition-all whitespace-nowrap"
              >
                <i className={`${cat.icon} text-sm`}></i>
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-6 text-white/60 text-sm">
          <div className="flex items-center gap-1.5">
            <i className="ri-play-circle-line text-lg"></i>
            <span>10万+ 视频资源</span>
          </div>
          <div className="w-px h-4 bg-white/20"></div>
          <div className="flex items-center gap-1.5">
            <i className="ri-user-line text-lg"></i>
            <span>5000万+ 用户</span>
          </div>
          <div className="w-px h-4 bg-white/20"></div>
          <div className="flex items-center gap-1.5">
            <i className="ri-hd-line text-lg"></i>
            <span>4K超高清</span>
          </div>
        </div>
      </div>
    </section>
  );
}